import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import soundEffects from '../utils/soundEffects';
import { createRipple } from '../utils/vfx';
import './BottomNav.css';

const PUBLIC = process.env.PUBLIC_URL || '';

// Single source of truth for the bottom navigation. The active tab is derived
// from the current route, so individual pages don't have to hard-code it.
const BottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = useUser();
  const path = location.pathname;

  const inLeague = !!state.user?.leagueId;

  const go = (e, to) => {
    soundEffects.playClick();
    createRipple(e, '#f27377');
    navigate(to);
  };

  const learnActive =
    ['/learn', '/course', '/teacher-lesson', '/teacher-quiz'].some((p) => path.startsWith(p));
  const simulateActive = path.startsWith('/simulations') || path.startsWith('/portfolio');

  const items = [
    { key: 'home', label: 'Home', icon: 'nav-home.svg', to: '/dashboard', active: path.startsWith('/dashboard') },
    { key: 'learn', label: 'Learn', icon: 'nav-learn.svg', to: '/learn', active: learnActive },
    { key: 'ask', label: 'Ask', icon: 'nav-ask.svg', to: '/ask', active: path.startsWith('/ask') },
    inLeague
      ? { key: 'class', label: 'Class', icon: 'nav-forum.svg', to: '/class', active: path.startsWith('/class') }
      : { key: 'forum', label: 'Forum', icon: 'nav-forum.svg', to: '/forum', active: path.startsWith('/forum') },
    { key: 'simulate', label: 'Simulate', icon: 'nav-simulate.svg', to: '/simulations', active: simulateActive },
  ];

  return (
    <nav className="nav-bottom" aria-label="Primary">
      {items.map((item) => (
        <button
          key={item.key}
          type="button"
          onClick={(e) => go(e, item.to)}
          onMouseEnter={() => soundEffects.playHover()}
          className={`nav-item${item.active ? ' active' : ''}`}
          aria-current={item.active ? 'page' : undefined}
        >
          <img src={`${PUBLIC}/${item.icon}`} alt="" aria-hidden="true" className="nav-item-icon" />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
};

export default BottomNav;
